import * as React from 'react';
import { Translate } from 'react-jhipster';
import { Row, Col } from 'reactstrap';

export class AboutUs extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <Row className="justify-content-center">
        <Col md="8" className="bg-white">
          <Row className="justify-content-center">
            <Col md="8" className="m-3">
              <h1>
                <Translate contentKey="static.aboutus.title">關於我們</Translate>
              </h1>
              <br />
              <p>
                <Translate contentKey="static.aboutus.text1">
                  PATO ENTERTAINMENT
                  是新一代的票務平台。我們主要提供低成本、功能靈活的票務解決方案，並可提供紙質或電子門票。我們的使命是提供優質的服務並傳遞完美的價值。
                </Translate>
              </p>
              <br />
              {/*Facebook : <a href="https://www.facebook.com/" target="_blank">https://www.facebook.com/</a>
              <br/>
              Instagram : <a href="https://www.instagram.com/" target="_blank">https://www.instagram.com/</a>
              <br/>
              微博 : <a href="https://www.weibo.com/" target="_blank">https://www.weibo.com/</a>*/}
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default AboutUs;
